import * as lodash from 'lodash'
import * as moment from 'moment'

export function getBdcTimeOptions(interval: 30 | 60 = 30): { value: string; label: string }[] {
  return lodash.flatten(
    lodash.range(0, 24).map((h) => {
      if (interval === 30) {
        return [
          { value: h.toString().padStart(2, '0') + ':00', label: moment().hour(h).minute(0).format('hh:mm A') },
          { value: h.toString().padStart(2, '0') + ':30', label: moment().hour(h).minute(30).format('hh:mm A') },
        ]
      } else {
        return [{ value: h.toString().padStart(2, '0') + ':00', label: moment().hour(h).minute(0).format('hh:mm A') }]
      }
    })
  )
}
